import { validateSomething } from "../../Form/Validations";

export class SDB {
    /**
   * @returns {import("../types").DialogState}
   */
    static actionDialogState(t, data) {
        return {
            visible: true,
            nombre_servicio: data.nombre_servicio,
            data: {},
            activeStep: 0,
            resolveBody: (values, props) => {
                const body = {
                    set_password: values.setPassword === "true" ? true : false,
                };
                if (body.set_password) body.password = values.password;
                return { url: `/farms/${props.farmId}/sdb/crear`, body};
            },
            steps: [
                {
                    label: t("external.conectar"),
                    inputs: [
                        {
                            label: t("sdb.set_password"),
                            campo: "setPassword",
                            component: "radioGroup",
                            validation: validateSomething,
                            radioGroup: [
                                { id: "sdb.manual", value: "true", label: t("sdb.manual") },
                                {
                                    id: "sdb.autogenerada",
                                    value: "false",
                                    label: t("sdb.autogenerada"),
                                },
                            ],
                        },
                        {
                            useCampo2: true,
                            label: t("external.password"),
                            campo: "password",
                            validation: validateSomething,
                            component: "text",
                            eyeForPassword: true,
                            type: "password",
                            triggeredBy: "setPassword",
                            valueEqualsTo: "true",
                        },
                    ],
                },
            ],
        };
    }

    /**
   * @returns {import("../types").DialogState}
  */
    static updateFormState(t, data) {
        return {
            visible: true,
            nombre_servicio: data.nombre_servicio,
            data: {},
            activeStep: 0,
            oldData: {
                password: data.connection_data?.password
            },
            resolveBody: (values, props) => {
                const body = {
                    set_password: values.setPassword === "true" ? true : false,
                    password: null
                };
                if (body.set_password) body.password = values.password;
                return { url: `/farms/${props.farmId}/sdb/update/${data.connection_data.usuario_id}`, body };
            },
            skipReviewStep: true,
            skipCostStep: true,
            hideStepper: true,
            confirmButtonLabel: t("general.confirm"),
            steps: [
                {
                    label: t("forms.update"),
                    inputs: [
                        {
                            label: t("sdb.set_password"),
                            campo: "setPassword",
                            component: "radioGroup",
                            validation: validateSomething,
                            radioGroup: [
                                { id: "sdb.manual", value: "true", label: t("sdb.manual") },
                                {
                                    id: "sdb.autogenerada",
                                    value: "false",
                                    label: t("sdb.autogenerada"),
                                },
                            ],
                        },
                        {
                            useCampo2: true,
                            label: t("external.password"),
                            campo: "password",
                            validation: validateSomething,
                            component: "text",
                            eyeForPassword: true,
                            type: "password",
                            triggeredBy: "setPassword",
                            valueEqualsTo: "true",
                        },
                    ],
                },
            ],
        };
    }
}
